import React from 'react';
import { DateSelectPageContent } from 'pages/date-select-page/components/date-select-page-content';
import { TimeSelectPageContent } from 'pages/time-select-page/components/time-select-page-content';
import { DateTimeSelectPageContentProps } from '../interface';

export const DateTimeSelectPageContent = ({ isDateStep }: DateTimeSelectPageContentProps): JSX.Element => {
  return isDateStep ? <DateSelectPageContent /> : <TimeSelectPageContent />;
};
